<template>
  <label class="toggle-switch" :class="{disabled}">
    <input
        type="checkbox"
        class="toggle-switch-input"
        :checked="modelValue"
        :disabled="disabled"
        :aria-label="label"
        @click.stop
        @change="onChange"
    />
    <span class="toggle-switch-track">
      <span class="toggle-switch-thumb"></span>
    </span>
    <span v-if="label" class="toggle-switch-label">{{ label }}</span>
  </label>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    onChange(event) {
      const value = event.target.checked;
      this.$emit('update:modelValue', value);
      this.$emit('change', value);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.toggle-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
}

.toggle-switch-input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.toggle-switch-track {
  position: relative;
  width: 42px;
  height: 24px;
  background: #b8b8b8;
  border-radius: 999px;
  transition: background-color 0.2s ease;
}

.toggle-switch-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease;
}

.toggle-switch-input:checked + .toggle-switch-track {
  background: $tracking-accent;
}

.toggle-switch-input:checked + .toggle-switch-track .toggle-switch-thumb {
  transform: translateX(18px);
}

.toggle-switch-input:focus-visible + .toggle-switch-track {
  outline: 2px solid $tracking-accent;
  outline-offset: 2px;
}

.toggle-switch-label {
  color: $default-text-color;
  font-size: 0.8rem;
  font-weight: 600;
}
</style>
